import * as _ from 'lodash';

import {
    ConnectionPoint, ConnectionPointStatus, ConnectionPointTestResult,
    ResultsStatus
} from '../../models/index';
import { StoreItem } from '../../stateManagement';
import { connectionPointStatusDictionary } from './connectionPointStatus.dictionary';

let cpStatuses: number[] = [];
for (const item of Object.keys(ConnectionPointStatus)) {
    if (!isNaN(Number(item))) {
        cpStatuses.push(Number(item));
    }
}
cpStatuses = cpStatuses.sort((a, b) => a < b ? 1 : -1);

export interface ConnectionPointCharmData {
    level: ResultsStatus;
    message: string;
    params: { [key: string]: any };
}


export function mapConnectionPointCharm(connectionPoints: StoreItem<ConnectionPoint>,
    connectionPointsStatuses: StoreItem<ConnectionPointTestResult>): ConnectionPointCharmData {
    const cpList = _.values<ConnectionPoint>(connectionPoints.dictionary);
    const statusList = _.values<ConnectionPointTestResult>(connectionPointsStatuses.dictionary);
    const count = cpList.length;

    let level: ResultsStatus = ResultsStatus.Ok;
    let message: string = null;
    let params: { [key: string]: any } = {};
    if (connectionPoints.isLoading
        || !connectionPoints.isLoaded
        || connectionPointsStatuses.isLoading
        || !connectionPointsStatuses.isLoaded) {
    } else if (count === 0) {
        level = ResultsStatus.Warning;
        message = 'No connection point defined';
    } else {
        let statusCount = 0;
        let errorCount = 0;
        for (let i = 0; i < cpStatuses.length; i++) {
            const status = cpStatuses[i];
            statusCount = statusList.filter(s => s.status === status).length;
            if (statusCount > 0 
                && status !== ConnectionPointStatus.OK 
                && status !== ConnectionPointStatus.NotTested) {
                const messageItem = connectionPointStatusDictionary[status];
                if (messageItem) {
                    message = messageItem.message;
                    level = messageItem.level;
                } else {
                    message = 'Unknown error';
                    level = ResultsStatus.Error;
                }
                errorCount += statusCount;
            }
        }
        if (errorCount > 1) {
            message = '_unavailableConnectionPointsCount_ connection point(s) unavailable';
        }
        params = {
            unavailableConnectionPointsCount: errorCount
        };
    }
    return { level, message, params };
}